import { gql } from '@apollo/client';

export default {
    FETCH_T_PDCAS: gql`
        query FETCH_T_PDCAS(
            $lgcode: String!
            $createdYear: Int!
            $jigyoYear: Int!
            $jigyoYearPrev: Int!
            $processCd: Int!
            $branchCd: String = "z"
        ) {
            pdca_t_pdca(
                where: {
                    lgcode: { _eq: $lgcode }
                    created_year: { _eq: $createdYear }
                    process_cd: { _eq: $processCd }
                    _is_deleted: { _eq: false }
                }
            ) {
                id
                jigyo_name
                m_soshiki_division_id_main
                tantou_kakari_main
                jigyo_gaiyo
                t_jigyo {
                    id
                    yosan_kan
                    yosan_kan_cd
                    yosan_kou
                    yosan_kou_cd
                    yosan_moku
                    yosan_moku_cd
                    keikaku_jigyo_cd
                    new_or_continue
                    jigyo_hyoji_num
                    c_jimu_jigyo_seisaku_shisakus(where: { _is_deleted: { _eq: false } }) {
                        id
                        m_seisaku_shisaku_id
                    }
                    m_jisshi_keikaku {
                        id
                    }
                    m_kaikei {
                        kaikei_name
                    }
                }
            }
            pdca_t_jigyohi(
                where: {
                    lgcode: { _eq: $lgcode }
                    created_year: { _eq: $createdYear }
                    branch_cd: { _eq: $branchCd }
                    _and: [{ jigyo_year: { _gte: $createdYear } }, { jigyo_year: { _lte: $jigyoYear } }]
                }
            ) {
                id
                jigyo_year
                jigyohi
                zaigen_chihosai
                zaigen_ippan
                zaigen_ken
                zaigen_kikin
                zaigen_kuni
                zaigen_other
                m_jisshi_keikaku_id
                process_cd
            }
            pdca_t_kessan(where: { lgcode: { _eq: $lgcode }, jigyo_year: { _in: [$jigyoYear, $jigyoYearPrev] } }) {
                id
                jigyo_year
                jigyohi
                zaigen_chihosai
                zaigen_ippan
                zaigen_ken
                zaigen_kikin
                zaigen_kuni
                zaigen_other
                m_jisshi_keikaku_id
            }
            pdca_m_soshiki_division(
                where: { lgcode: { _eq: $lgcode }, _is_deleted: { _eq: false }, _is_hidden: { _eq: false } }
                order_by: { division_cd: asc }
            ) {
                id
                division_cd
                division_name
            }
            pdca_m_seisaku_shisaku(
                where: { lgcode: { _eq: $lgcode }, _is_deleted: { _eq: false } }
                order_by: { seisaku_shisaku_cd: asc }
            ) {
                id
                parent_cd
                seisaku_shisaku_cd
                seisaku_shisaku_name
                level
                m_keikaku_id
            }
            pdca_m_keikaku(where: { lgcode: { _eq: $lgcode } }) {
                id
                keikaku_name
            }
        }
    `,

    FETCH_T_PDCA_ID: gql`
        query FETCH_T_PDCA_ID(
            $_id: uuid! = "bc00bfe0-ccbf-4d0e-8fad-aa1bc368a065"
            $_lgcode: String! = "313718"
            $jigyoYear: Int! = 2025
            $createdYear: Int!
            $_gte_jigyo_year: Int! = 2023
            $_lte_jigyo_year: Int! = 2027
            $_created_year: Int! = 2023
            $_lte_kessan_year: Int! = 2022
            $_gte_kessan_year: Int! = 2022
            $_process_cd: Int! = 30
            $_branch_cd: String! = "z"
        ) {
            pdca_t_pdca(
                where: {
                    _is_deleted: { _eq: false }
                    t_jigyo: { m_jisshi_keikaku_id: { _eq: $_id }, jigyo_year: { _gte: $_created_year, _lte: $jigyoYear } }
                }
            ) {
                id
                jigyo_gaiyo
                jigyo_memo
                jigyo_name
                kaizen_keika
                jiseki_koka
                hitsuyosei
                tantou_kakari_main
                process_cd
                branch_cd
                hyoka_satei_class_a_memo
                hyoka_satei_class_b_memo
                hyoka_satei_class_c_memo
                hyoka_satei_class_d_memo
                t_jigyo {
                    c_jimu_jigyo_seisaku_shisakus(where: { _is_deleted: { _eq: false } }) {
                        id
                        m_seisaku_shisaku_id
                        m_seisaku_shisaku {
                            seisaku_shisaku_name
                            seisaku_shisaku_cd
                            parent_cd
                            m_keikaku_id
                            level
                        }
                    }
                    t_sai_jigyos(where: { _is_deleted: { _eq: false } }) {
                        id
                        saijigyo_name
                        saijigyo_naiyo
                        saijigyo_kind
                        zaigen_uchiwake
                        sort
                        change_point
                        process_cd
                        c_sai_jigyo_saishutsu_yosans(where: { _is_deleted: { _eq: false } }) {
                            id
                            _is_deleted
                            t_saishutsu_yosan {
                                id
                                saishutsu_yosan
                                _is_deleted
                            }
                        }
                    }
                    t_files {
                        _is_deleted
                        id
                        file_path
                        file_name
                        size
                    }
                    m_jisshi_keikaku {
                        t_jigyohis(
                            where: {
                                branch_cd: { _eq: $_branch_cd }
                                created_year: { _eq: $createdYear }
                                _and: [{ jigyo_year: { _gte: $createdYear } }, { jigyo_year: { _lte: $jigyoYear } }]
                            }
                        ) {
                            id
                            jigyo_year
                            created_year
                            jigyohi
                            process_cd
                            branch_cd
                            shokuin_kaikeinendo_kingaku
                            shokuin_kaikeinendo_num
                            shokuin_num
                            shokuin_saininyo_num
                            zaigen_chihosai
                            zaigen_ippan
                            zaigen_ken
                            zaigen_kikin
                            zaigen_kuni
                            zaigen_kurikoshi
                            zaigen_other
                        }
                        t_kessans {
                            id
                            jigyo_year
                            jigyohi
                            zaigen_kuni
                            zaigen_chihosai
                            zaigen_ippan
                            zaigen_ken
                            zaigen_kikin
                            zaigen_kurikoshi
                            zaigen_other
                            shokuin_num
                            shokuin_kaikeinendo_num
                            shokuin_kaikeinendo_kingaku
                            shokuin_saininyo_num
                            gen_kuri
                            yosan_gengaku
                        }
                        t_kpi_values(where: { _is_deleted: { _eq: false }, process_cd: { _eq: $_process_cd } }) {
                            id
                            jigyo_year
                            kijun_val
                            kijun_year
                            jisseki_val
                            kpi_sort
                            mokuhyo_val
                            process_cd
                            shihyo_cd
                            shihyo_kind
                            shihyo_name
                            shutten
                            tani
                            tassei_rate
                            t_sai_jigyo_id
                            t_sai_jigyo {
                                saijigyo_name
                            }
                        }
                    }
                    m_kaikei {
                        kaikei_name
                    }
                    jigyo_year
                }
                m_soshiki_division {
                    division_name
                    division_cd
                }
            }
            pdca_m_keikaku(where: { lgcode: { _eq: $_lgcode } }) {
                id
                keikaku_name
            }
        }
    `,
};
